import { Component } from 'react'
import moment from 'moment'
import { HistoryUtil } from '@vzmi/component_ec_nodejs_util/dist/lib'
import { getFeatureToggle } from '@vzmi/component_ec_nodejs_util/dist/lib/FeatureToggleUtil'
import _ from 'lodash'
import {
  PRODUCT_WARRANTY_SCOPE_LIST,
  PRODUCT_WARRANTY_STATUS,
  PRODUCT_WARRANTY_STATUS_MAP,
  PROPOSAL_REVIEW_STATUS,
  PROPOSAL_TYPE
} from '@vzmi/shp_shared_compo/constants/proposal'

import errorHelper, { resHandler } from '../../../../lib/errorHelper'
import { PAGE_FLOW, PROPOSAL_PHASE_TYPE, EXTRA_MODEL_VALUES, WARRANTY_SCOPE_OTHER } from '../../../constants/proposalTypes'
import { createErrorToast, formRequestHandler, updateSyncErrorsByFormError } from '../../../lib/FormHelper'
import withSupplierSharedLink from '../../Common/HOC/withSupplierSharedLink'
import withCommonPage from '../../Common/HOC/withCommonPage'
import { withI13nWrapper } from '../../Common/I13nWrapper'
import BeforeUnload, { unbindBeforeunload } from '../Common/BeforeUnload'
import withUpdateListingForm from '../Common/HOC/withUpdateListingForm'
import { withHTMLCheck, withVideoCheck, extractTransientProduct } from '../Common/ProposalForm/Shared/util'
import { getProposalById, postLoadFormat } from '../ProductListingBaseForm/helpers/getters'
import { checkEditableProposal, redirectToProposalFeature } from '../Shared'
import {
  RENDER_ID,
  transformFetchedToLoadingData,
  checkModelsHasChangedBy,
  adjustModels,
  switchProposalType,
  adjustImages,
  adjustListingInPlaceWith
} from './helpers/converters'
import UpdateListingForm from './UpdateListingForm'
import { getFirstOrderVideos } from '../../../lib/listingUtil'
import { updateModelImages } from './helpers/updateImageHelper'
import {
  getModelsForUpdateAttr,
  getOuterSpecs,
  getCandidateStruDataList
} from './helpers/updateAttrHelper'
import { transformWarrantyScope } from '../ProductListingBaseForm/helpers/convertors'
import {
  FORM as EXTRA_MODEL_TABLE_FORM,
  TABLE_TYPE as EXTRA_MODEL_TABLE_TYPE,
  TABLE_GROUP_BY_GROUP_SKU as EXTRA_MODEL_TABLE_GROUP_BY_GROUP_SKU,
  TABLE_GROUP_TYPE as EXTRA_MODEL_TABLE_GROUP_TYPE,
  GROUP_SKU_KEY as EXTRA_MODEL_GROUP_SKU_KEY,
  getExtraModelsPayload
} from '../ProductListingBaseForm/ListingModel/ExtraModelTable/helper'

const PRIMITIVE_FORM_DATA = {
  type: PROPOSAL_TYPE.UPDATE_COPY,
  id: null,
  subStationId: null,
  applicant: null,
  listing: {
    id: null,
    copy: null,
    warranty: null,
    skuDetail: {
      shipType: {}
    }
  }
}

const DEFAULT_FORM_DATA = {
  mustShowFormError: false,
  setting: {},
  ...PRIMITIVE_FORM_DATA
}

/**
 * get `fields`, which is a parameter for GET /spa/v1/listings/{id}
 *
 * @param proposalType
 * @returns Returns `[...fields]`
 */
const getExcludedFields = proposalType => {
  const options = [
    '-copy',
    '-images',
    '-videos',
    '-complimentaries',
    '-additionalPurchases',
    '-selectComplimentaries',
    '-productStructuredDataList'
  ]

  const excludedFields = options.filter(field => {
    switch (proposalType) {
      case PROPOSAL_TYPE.UPDATE_COPY: {
        return !['-copy', '-images'].includes(field)
      }
      case PROPOSAL_TYPE.UPDATE_VIDEO: {
        return !['-videos', '-images'].includes(field)
      }
      case PROPOSAL_TYPE.UPDATE_ATTRIBUTE: {
        return !['-productStructuredDataList', '-images'].includes(field)
      }
      case PROPOSAL_TYPE.UPDATE_IMAGE: {
        return _.includes(['-copy', '-videos', '-productStructuredDataList'], field)
      }
      default:
        return false
    }
  })

  return excludedFields
}

export class UpdateListingMain extends Component {
  constructor (props) {
    super(props)
    this.state = {
      initialFormValues: null,
      currentUpdateFormRef: null,
      postingProposal: {}
    }
  }

  componentDidMount () {
    const matchPhase = _.get(this.props, 'match.params.phase')
    if (matchPhase === PROPOSAL_PHASE_TYPE.OVERVIEW) {
      unbindBeforeunload()
    }
  }

  setCurrentUpdateFormRef = ref => this.setState({ currentUpdateFormRef: ref })

  getCurrentUpdateFormRef = () => this.state.currentUpdateFormRef

  loadForm = async formData => {
    if (_.isNull(this.state.initialFormValues)) {
      // 傳入的 reference 會跟著表單變動，所以需要用 deep clone 確保這是最一開始 fetch 得到的 form data
      this.setState({ initialFormValues: _.cloneDeep(formData) })
    }
    this.props.initialize(formData)
    // 按下完成提案待 post proposal 完成後執行
    const afterComplete = _.get(this.getCurrentUpdateFormRef(), 'afterComplete')
    afterComplete && afterComplete(formData)
  }

  handleGetFormDataError = error => {
    const errorCode = _.get(error, 'code', '').toString()
    const errorMsg = errorHelper.parseErrorMessage(error)

    if (errorCode) {
      createErrorToast({
        message: `${errorCode} ${errorMsg}`,
        error
      })
    } else {
      const { proposalTypeName } = this.props
      const customMsg = `準備${proposalTypeName}資料時發生錯誤`
      _.set(error, 'message', customMsg)
      createErrorToast({
        message: customMsg,
        error
      })
    }

    this.moveToErrorPage(error)
  }

  /**
   * 進錯誤頁
   */
  moveToErrorPage = (error = {}) => {
    this.form.handlePageMoveTo(
      PAGE_FLOW.ERROR,
      {
        error: {
          code: error.code || '',
          message: error.message || ''
        }
      }
    )
  }

  getFormSetting = () => {
    const {
      user,
      setting = {},
      proposalType,
      subStationOptions
    } = this.props

    return {
      ...setting,
      user,
      proposalType,
      subStationOptions
    }
  }

  /**
   * fetch 特定賣場
   *
   * */
  getSpecificListing = async listingId => {
    const {
      actions,
      proposalType
    } = this.props

    const reqPayload = {
      id: listingId,
      fields: getExcludedFields(proposalType)
    }

    try {
      const resPayload = await actions
        .fetchSpecificListing(reqPayload)
        .then(res => {
          const isOverview = _.isEqual(
            _.get(this.props, 'match.params.phase'),
            PROPOSAL_PHASE_TYPE.OVERVIEW
          )
          // 賣場不存在或是過期查不到
          const isListingNotFound = (
            _.get(res, 'payload.errorData.error[0].code') === 40411000
          )
          if (isOverview && isListingNotFound) {
            return { id: listingId, name: '--', isListingNotFound: true }
          }
          return resHandler(res)
        })

      return {
        listingId,
        ...resPayload
      }
    } catch (error) {
      console.log('getListing 錯誤', error)
      throw error
    }
  }

  /**
   * fetch 特定提案單
   */
  getSpecificProposal = async proposalId => {
    const { actions, proposalType } = this.props

    try {
      const proposal = await getProposalById(actions, proposalId, proposalType)
      switchProposalType(proposal)

      return {
        ...proposal,
        proposalId
      }
    } catch (error) {
      console.log('getSpecificProposal 錯誤', error)
      throw error
    }
  }

  getSubStationId = async fetchedData => {
    let subStationId = fetchedData.subStationId || fetchedData.listing.subStationId

    /**
      * 用 catItemId 去取 subStationId
      */
    if (!subStationId) {
      try {
        const catItemId = _.get(fetchedData, 'catItemId', '')
        subStationId = await this.fetchSubStationId(catItemId)
      } catch (error) {
        console.log('getSubStationId 錯誤', error)
        throw error
      }
    }

    return subStationId
  }

  fetchSubStationId = async catItemId => {
    const {
      actions
    } = this.props

    try {
      const fetchedSubStationId = await actions
        .fetchSubStationIdByCatItemId({ catItemId })
        .then(resHandler)
      return fetchedSubStationId
    } catch (error) {
      this.moveToErrorPage({ message: '賣場子站有誤，請聯繫業務窗口' })
      console.log('fetchSubStationId 錯誤', error)
      throw error
    }
  }

  /**
   * 預設的各個欄位資料
   */
  getDefaultUpdateListingFormValues = () => {
    const {
      user,
      proposalType
    } = this.props

    // 供應商登入: 預設帶入小幫手名稱，小幫手可自行修改
    // 模擬登入：預設帶入小幫手名稱，小幫手可自行修改
    // 提案人 PM 仿供應商登入：顯示該 PM 之中文姓名 (不提供修改)
    const applicant = _.get(user, 'identity.name', '')

    return {
      ...DEFAULT_FORM_DATA,
      applicant,
      type: proposalType,
      setting: this.getFormSetting()
    }
  }

  getProposalForLoading = async fetchedData => {
    const {
      proposalType,
      match
    } = this.props
    const proposalPhaseFromUrl = _.get(match, 'params.phase')
    const isOverview = proposalPhaseFromUrl === PROPOSAL_PHASE_TYPE.OVERVIEW

    const fetchedFormValues = this.getUpdateListingFormValues(proposalType)(fetchedData)

    const defaultFormValues = this.getDefaultUpdateListingFormValues()

    const subStationId = await this.getSubStationId(fetchedData)

    const proposalForLoading = transformFetchedToLoadingData({
      ...defaultFormValues,
      ...fetchedFormValues,
      subStationId
    }, isOverview)

    if (proposalType === PROPOSAL_TYPE.UPDATE_ATTRIBUTE) {
      // 備註：修改賣場規格表overview會進到這段 redux from data 無 get proposal parent  要另外convertors
      const postLoadFormattedProposal = await postLoadFormat(
        this.props,
        {},
        proposalForLoading
      )

      return postLoadFormattedProposal
    }

    return proposalForLoading
  }

  checkIsSpecificProposalType = proposalType => _.includes([
    PROPOSAL_TYPE.UPDATE_LISTING_MODEL
  ], proposalType)

  getFormData = async () => {
    const {
      match,
      location,
      proposalType,
      actions: { invokeRedirect }
    } = this.props

    try {
      const {
        id: idFromUrl,
        listingId: listingIdFromUrl
      } = HistoryUtil.retrieveQueryParams({ location })
      const proposalPhaseFromUrl = _.get(match, 'params.phase', null)
      const isOverview = proposalPhaseFromUrl === PROPOSAL_PHASE_TYPE.OVERVIEW

      let proposal = null
      if (isOverview) {
        proposal = await this.getSpecificProposal(idFromUrl)
      }

      const listing = await this.getSpecificListing(
        _.isNull(proposal)
          ? listingIdFromUrl || idFromUrl
          : _.get(proposal, 'listing.id')
      )

      const loadingProposal = await this.getProposalForLoading({
        listing,
        proposal
      })

      if (isOverview) {
        const isSpecificProposalType = this.checkIsSpecificProposalType(proposalType)
        const fetchedProposalType = _.get(proposal, 'type')
        const isCorrectProposalType = (
          (fetchedProposalType === proposalType) ||
          // 在特別的 proposal 中 api resp 不會回傳 proposalType
          // 因為這些 api 可能本身就是針對這個 type 在處理
          // 檢視頁只要 proposal 不是空的就代表是正確的
          (isSpecificProposalType && !_.isEmpty(proposal))
        )

        if (!isCorrectProposalType) {
          redirectToProposalFeature(
            invokeRedirect,
            fetchedProposalType,
            proposalPhaseFromUrl,
            idFromUrl
          )
          return {}
        }

        switch (proposalPhaseFromUrl) {
          case PROPOSAL_PHASE_TYPE.OVERVIEW: {
            _.set(loadingProposal, 'setting.readOnly', true)
            break
          }
          case PROPOSAL_PHASE_TYPE.COMPOSE:
          default: {
            const reviewStatus = _.get(proposal, 'reviewStatus')
            const isEditableProposal = checkEditableProposal(reviewStatus)
            if (!isEditableProposal) { return }
            break
          }
        }
      }

      return loadingProposal
    } catch (error) {
      console.log('updateListing getFormData 錯誤', error)
      this.handleGetFormDataError(error)
    }
  }

  /**
   * 依據 proposalType 從 fetched listing 跟 fetched proposal 中取出所需欄位，
   *  @returns {proposal} 提案單form
   */
  getUpdateListingFormValues = proposalType => fetchedFormData => {
    const {
      listing: fetchedListing,
      proposal: fetchedProposal
    } = fetchedFormData

    const adjust = adjustListingInPlaceWith([
      adjustModels,
      listing => adjustImages(listing, proposalType)
    ])

    adjust(fetchedListing)
    const fetchedProposalListing = _.get(fetchedProposal, 'listing', null)
    if (fetchedProposalListing) {
      // updateProposals 如果是無屬性賣場因為 modals 要自己組，且回傳值不會有 sku，所以要從原本的 listing 組回來
      const currentSKU = _.get(fetchedListing, 'sku')
      _.set(fetchedProposalListing, 'sku', currentSKU)
      adjust(fetchedProposalListing)
    }

    const requiredValues = {
      ...fetchedProposal,
      initiallyFetchedListing: fetchedListing,
      listing: _.pick(fetchedListing, ['id', 'swCode'])
    }

    switch (proposalType) {
      case PROPOSAL_TYPE.UPDATE_COPY: {
        const proposalPhaseType = _.get(this.props, 'match.params.phase')
        const isOverview = (proposalPhaseType === PROPOSAL_PHASE_TYPE.OVERVIEW)
        const shipTypeInListing = _.get(fetchedListing, 'skuDetail.shipType')
        const copyInProposalListing = _.get(fetchedProposal, 'listing.copy')
        const copyInListing = _.get(fetchedListing, 'copy')
        // 確認頁、檢視頁新的保固需要從 proposal listing 拿到修改的內容
        const warrantyInProposalListing = _.get(fetchedProposal, 'listing.warranty', null)
        // 進入修改頁時會從 get listing 拿到目前保固內容
        const warrantyInListing = _.get(fetchedListing, 'warranty')
        // 2021-08-19 上線可同時修改賣場詳情與商品保證後屬於新的修改詳情
        // 舊的修改詳情不顯示商品保證區塊
        // https://screwdriver.ouroath.com/pipelines/208631/events/17624205
        const isOldUpdateCopy = (
          _.isEmpty(fetchedProposalListing)
            ? false
            : moment(_.get(fetchedProposal, 'createdTs')).isBefore('2021-08-19')
        )

        const checkedCopy = withHTMLCheck(copyInProposalListing || copyInListing)
        let currentWarranty = isOverview
          // 檢視頁只看提案裡修改後的商品保固
          ? warrantyInProposalListing
          : (warrantyInProposalListing || warrantyInListing || {})
        const currentWarrantyScope = _.get(currentWarranty, 'scope')
        // 保固範圍不屬於現有的，代表是"其他"，因此 scope 會取代成其他並且輸入匡寫入實際的 scope 內容
        if (
          currentWarrantyScope &&
          !_.includes(PRODUCT_WARRANTY_SCOPE_LIST, currentWarrantyScope)
        ) {
          currentWarranty = {
            ...currentWarranty,
            scope: WARRANTY_SCOPE_OTHER,
            custom_scope: currentWarrantyScope
          }
        }

        if (!_.isNull(currentWarranty)) {
          const statusKey = 'productStatus'
          const { [statusKey]: productStatus } = currentWarranty
          if (_.isUndefined(productStatus)) {
            _.set(currentWarranty, statusKey, PRODUCT_WARRANTY_STATUS.NEW)
          }

          if (!(productStatus in PRODUCT_WARRANTY_STATUS_MAP)) {
            _.set(currentWarranty, statusKey, null)
          }
        }

        _.merge(
          requiredValues,
          {
            listing: {
              copy: checkedCopy,
              skuDetail: {
                shipType: shipTypeInListing
              }
            },
            product: {
              warranty: currentWarranty,
              isOldUpdateCopy,
              isUpdateWithWarranty: (
                // 沒有 proposal listing 代表在修改或是檢視
                _.isEmpty(fetchedProposalListing)
                  // proposal listing 沒有商品保證代表取消勾選同時修改商品保證，只修改詳情
                  ? true
                  : !_.isNull(warrantyInProposalListing)
              )
            }
          }
        )
        break
      }

      case PROPOSAL_TYPE.UPDATE_VIDEO: {
        const listingInProposal = _.get(fetchedProposal, 'listing')
        const checkedVideos = withVideoCheck(
          getFirstOrderVideos(listingInProposal || fetchedListing)
        )

        const fetchedListingModels = _.get(fetchedListing, 'models')

        _.merge(
          requiredValues,
          {
            listing: {
              models: fetchedListingModels,
              videos: checkedVideos
            }
          }
        )
        break
      }

      case PROPOSAL_TYPE.UPDATE_IMAGE: {
        const allUpdatedModels = ['models', ...EXTRA_MODEL_VALUES]
          .reduce((acc, cur) => {
            const listingModels = _.get(fetchedListing, cur, null)
            if (listingModels) {
              const proposalListingModels = _.get(fetchedProposal, `listing.${cur}`)
              const updatedModels = updateModelImages(listingModels, proposalListingModels)
              acc[cur] = updatedModels
            }
            return acc
          }, {})

        const allModelsList = _.flatten(_.values(allUpdatedModels))
        allModelsList.forEach((model, idx) => {
          const _hasSameSku = o => o.sku === _.get(model, 'sku')

          const firstIdxInList = _.findIndex(allModelsList, _hasSameSku)
          const lastIdxInList = _.findLastIndex(allModelsList, _hasSameSku)

          const duplicated = firstIdxInList !== lastIdxInList

          const editable = !duplicated || firstIdxInList === idx

          _.set(model, 'editable', editable)
        })

        const newProposalListing = _.assign(
          {},
          fetchedListing,
          _.pick(
            _.isNull(fetchedProposalListing)
              ? ({
                attributeDisplayMode: 'table',
                syncProductImages: true
              })
              : fetchedProposalListing,
            [
              'attributeDisplayMode',
              'syncProductImages',
              'shareMediaBetweenModels'
            ]),
          allUpdatedModels
        )

        _.merge(
          requiredValues,
          {
            listing: newProposalListing
          }
        )
        break
      }

      case PROPOSAL_TYPE.UPDATE_ATTRIBUTE: {
        const hasProposalListing = !_.isNull(fetchedProposalListing)

        const {
          zoneId,
          catId,
          catItemId,
          isNoModelsListing
        } = fetchedListing

        const attributeDisplayMode = (
          _.get(fetchedProposalListing, 'attributeDisplayMode') ||
          _.get(fetchedListing, 'attributeDisplayMode')
        )

        const fetchedListingModels = _.get(fetchedListing, 'models')

        const candidateStruDataList = getCandidateStruDataList(fetchedListing)

        const attributes = hasProposalListing
          ? _.get(fetchedProposalListing, 'attributes')
          : candidateStruDataList.length === 1 ? candidateStruDataList[0].attributes : null

        const struDataAttrClusterId = hasProposalListing
          ? _.get(fetchedProposalListing, 'struDataAttrClusterId')
          : candidateStruDataList.length === 1 ? _.get(fetchedListing, 'productStructuredDataList[0].struDataAttrClusterId') : null

        const specs = isNoModelsListing
          ? []
          : getOuterSpecs(fetchedListingModels)

        const models = isNoModelsListing
          ? {}
          : getModelsForUpdateAttr(fetchedListingModels)

        _.merge(
          requiredValues,
          {
            candidateStruDataList,
            product: {
              zoneId,
              catId,
              catItemId,
              attributeDisplayMode,
              attributes,
              struDataAttrClusterId,
              specs,
              models
            }
          }
        )
        break
      }

      case PROPOSAL_TYPE.UPDATE_LISTING_MODEL: {
        const proposalModels = _.get(fetchedProposal, 'models', [])
        const origLayer = _.get(fetchedProposal, 'listing.origLayer')
        const listingModels = _.get(fetchedListing, 'models', [])
        const updateListingModelTable = _.get(fetchedListing, 'updateListingModelTable', {})
        // 有提案(檢視頁)先找提案的 shareMediaBetweenModels 狀態
        // 否則找賣場的(修改頁) shareMediaBetweenModels
        const shareMediaBetweenModels = _.get(
          fetchedProposalListing,
          'shareMediaBetweenModels',
          _.get(fetchedListing, 'shareMediaBetweenModels')
        )
        const extraModelFields = _.flow(
          () => [
            EXTRA_MODEL_TABLE_TYPE.COMPLIMENTARIES,
            EXTRA_MODEL_TABLE_TYPE.SELECT_COMPLIMENTARIES,
            EXTRA_MODEL_TABLE_TYPE.ADDITIONAL_PURCHASES
          ],
          extraModelKeys => _.map(extraModelKeys, extraModelKey => {
            const extraModels = _.flow(
              () => _.get(fetchedListing, extraModelKey, []),
              models => _.map(models, (model, index) => {
                const groupSku = model[EXTRA_MODEL_GROUP_SKU_KEY]
                return {
                  ...model,
                  // 如果有 groupSku 強制轉換成字串避免經過 component 寫入後格式改變造成資料比對錯誤
                  ...(!_.isUndefined(groupSku) && {
                    [EXTRA_MODEL_GROUP_SKU_KEY]: `${groupSku}`
                  }),
                  [RENDER_ID]: index
                }
              })
            )()
            const extraModelGroupMapByGroupSku = _.flow(
              () => _.get(fetchedListing, EXTRA_MODEL_TABLE_GROUP_TYPE[extraModelKey], []),
              extraModelGroup => _.keyBy(
                _.map(extraModelGroup, item => {
                  const groupSku = item[EXTRA_MODEL_GROUP_SKU_KEY]
                  return {
                    ...item,
                    // 同 extraModels 強制轉換成字串
                    [EXTRA_MODEL_GROUP_SKU_KEY]: `${groupSku}`
                  }
                }),
                EXTRA_MODEL_GROUP_SKU_KEY
              )
            )()
            return {
              models: extraModels,
              field: extraModelKey,
              groupMap: extraModelGroupMapByGroupSku
            }
          }),
          extraModelList => {
            const fields = _.reduce(extraModelList, (modelFields, extraModel) => {
              const { field, models, groupMap } = extraModel
              // { complimentaries, selectComplimentaries }
              // 主要 extra models 資料列
              modelFields[field] = models
              // { complimentariesFieldValues, selectComplimentariesFieldValues }
              // FieldValues 是為了讓資料列在拖曳後可以更快取得變更後 input 上要顯示的資料而額外存的
              // 否則在拖曳後表格變更跟資料寫入有時間差會有一瞬間拖曳後 input 顯示拖曳前的欄位資料
              modelFields[EXTRA_MODEL_TABLE_FORM[field]] = _.keyBy(models, RENDER_ID)
              // { complimentaryGroupsMapByGroupSku, selectComplimentaryGroupsMapByGroupSku }
              // GroupSku 是為了讓有屬性 spec.name 改成對應 group 裡拿 groupName
              modelFields[EXTRA_MODEL_TABLE_GROUP_BY_GROUP_SKU[field]] = groupMap
              return modelFields
            }, {})
            return fields
          }
        )()
        // 如果有 proposalModels 代表這是修改過的狀態，所以不需要再從賣場取得舊的屬性商品
        let currentModels = _.isEmpty(proposalModels)
          ? listingModels
          : proposalModels
        const isNoLayerListing = _.isEmpty(
          _.get(currentModels, '0.spec.name')
        )
        if (isNoLayerListing) {
          currentModels = []
        }
        _.merge(requiredValues, {
          models: currentModels,
          listing: {
            ...fetchedListing,
            ...extraModelFields,
            shareMediaBetweenModels,
            origLayer
          },
          updateListingModelTable
        })
        break
      }
    }

    return requiredValues
  }

  transformFormDataToProposalData = (formValues, reviewStatus) => {
    const {
      type,
      listing,
      applicant,
      convertedModels,
      id: proposalId,
      initiallyFetchedListing,
      product
    } = formValues

    const proposingListing = _.pick(listing, [
      'id',
      'swCode',
      'syncProductImages',
      'shareMediaBetweenModels',
      'origLayer'
    ])

    switch (type) {
      case PROPOSAL_TYPE.UPDATE_COPY: {
        const copy = _.get(listing, 'copy', '')
        const warranty = transformWarrantyScope(_.get(product, 'warranty'))
        proposingListing.copy = copy
        if (product.isUpdateWithWarranty) {
          proposingListing.warranty = warranty
        }
        break
      }

      case PROPOSAL_TYPE.UPDATE_VIDEO: {
        const isNoModelsListing = _.get(initiallyFetchedListing, 'isNoModelsListing', false)

        const models = _.get(listing, 'models', [])
        const videos = _.get(listing, 'videos', [])
        const firstVideo = _.get(videos, '[0]', {})
        const updatingVideos = _.isEmpty(firstVideo)
          ? []
          : videos

        if (isNoModelsListing) {
          /**
           * 無屬性賣場
           * 不用帶 listing.models，
           * 只要 listing.videos 給 API 就好
           */
          _.set(proposingListing, 'videos', updatingVideos)
        } else {
          /**
       * 有 models 代表是 有屬性賣場，
       * 要把 videos 塞入每一個 model 中，
       * 帶 listing.models 給 API
       */
          const updatingModels = models.map(
            model => {
              const { sku } = model
              return {
                sku,
                videos: updatingVideos
              }
            }
          )

          _.set(proposingListing, 'models', updatingModels)
        }
        break
      }

      case PROPOSAL_TYPE.UPDATE_IMAGE: {
        const {
          models,
          shareMediaBetweenModels
        } = listing

        const existingListingModels = _.get(this.state.initialFormValues, 'initiallyFetchedListing.models', [])
        // 組出目前正確的賣場屬性
        const currentListingModels = _.map(existingListingModels, (model, idx) => {
          const { images = [], sku, ...rest } = model
          const firstOrderImagesMap = _.get(_.find(models, { sku }), 'firstOrderImages', {})
          // 商品首圖連結會拿來當該賣場對應表的 key
          const mainImageUrl = _.get(_.find(images, { order: 1, height: 1000 }), 'url')
          const currentFirstOrderImages = _.flow(
            map => _.get(map[mainImageUrl], 'currentImages', []),
            // 空的圖片連結代表被刪除
            currentImages => _.filter(currentImages, image => !_.isEmpty(image.url))
          )(firstOrderImagesMap)
          const currentImages = [
            // 非首圖的大圖加小圖與首圖大圖
            ..._.filter(images, ({ order, height }) => (order !== 1 || height === 1000)),
            // 首圖修改過的小圖
            ...currentFirstOrderImages
          ]
          return {
            ...rest,
            sku,
            image: currentImages
          }
        })

        const isNoModelsListing = _.get(initiallyFetchedListing, 'isNoModelsListing', false)

        const postFormatModels = models
          .filter(model => model.editable)
          .map(checkModelsHasChangedBy(currentListingModels))
          .filter(_.isObject)

        // 圖片沒有修改不需要送出
        if (!_.isEmpty(postFormatModels)) {
          if (isNoModelsListing) {
            _.set(proposingListing, 'images', _.get(postFormatModels, '[0].images', []))
          } else if (shareMediaBetweenModels) {
            _.set(proposingListing, 'models', [_.get(postFormatModels, '[0]')])
          } else {
            _.set(proposingListing, 'models', postFormatModels)
          }
        }

        EXTRA_MODEL_VALUES.forEach(extraModelName => {
          const extraModels = _.get(listing, extraModelName, null)
          if (extraModels) {
            const existingListingExtraModels = _.get(this.state.initialFormValues, `initiallyFetchedListing.${extraModelName}`, [])
            const postFormatExtraModels = extraModels
              .filter(model => model.editable)
              .map(checkModelsHasChangedBy(existingListingExtraModels))
              .filter(_.isObject)
            if (!_.isEmpty(postFormatExtraModels)) {
              _.set(proposingListing, extraModelName, postFormatExtraModels)
            }
          }
        })

        break
      }

      case PROPOSAL_TYPE.UPDATE_ATTRIBUTE: {
        const product = _.get(formValues, 'product', {})
        const {
          attributeDisplayMode,
          struDataAttrClusterId
        } = product

        const transientProduct = extractTransientProduct(formValues)
        const attributes = _.get(transientProduct, 'attributes')

        _.merge(proposingListing, {
          attributeDisplayMode,
          struDataAttrClusterId,
          attributes
        })
        break
      }

      case PROPOSAL_TYPE.UPDATE_LISTING_MODEL: {
        const complimentaryFeatureToggle = getFeatureToggle(this.props.flags, 'uListing2')
        const shortTitleFeatureToggle = getFeatureToggle(this.props.flags, 'sp_shortTitle')
        const extraModelsPayload = complimentaryFeatureToggle
          ? getExtraModelsPayload(listing, shortTitleFeatureToggle)
          : {}
        const isNoLayerListing = _.isEmpty(_.get(convertedModels, '0.spec.name'))
        let proposal = {
          applicant,
          listing: proposingListing,
          ...(!isNoLayerListing && { models: convertedModels }),
          ...extraModelsPayload,
          ...(proposalId && {
            id: proposalId,
            reviewStatus: PROPOSAL_REVIEW_STATUS.DRAFT
          })
        }
        if (reviewStatus === PROPOSAL_REVIEW_STATUS.PENDING_REVIEW) {
          proposal = {
            ...proposal,
            reviewStatus
          }
        }
        return proposal
      }
    }

    const proposal = {
      type,
      applicant,
      id: proposalId,
      listing: proposingListing,
      reviewStatus
    }

    return proposal
  }

  getPostAction = proposal => {
    const {
      proposalType,
      actions
    } = this.props
    const {
      createProposals,
      updateProposals,
      createListingModelProposals,
      updateListingModelProposals
    } = actions
    const proposalId = _.get(proposal, 'id', null)
    const isCreateAction = !proposalId
    let postAction
    switch (proposalType) {
      case PROPOSAL_TYPE.UPDATE_LISTING_MODEL: {
        postAction = isCreateAction
          ? createListingModelProposals
          : updateListingModelProposals
        break
      }
      default: {
        postAction = isCreateAction
          ? createProposals
          : updateProposals
        break
      }
    }
    return postAction
  }

  // 送出提案 api
  postProposal = async proposal => {
    switchProposalType(proposal)

    // 如果有提案編號則更新提案，否則新增提案
    const post = this.getPostAction(proposal)

    try {
      const promise = formRequestHandler(post(proposal))
      const updateListingSuccess = await promise.finally(() => {
        /** promise.finally is only available after `bluebird` imported */
        this.props.clearSubmitErrors()
      })
      updateListingSuccess.proposalId = updateListingSuccess.id
      return updateListingSuccess
    } catch (error) {
      console.error('postProposal fail', error)
      this.form.setIsFormLoading(false)
      throw error
    }
  }

  // 完成提案(draft) 或者 送出提案(pendingReview)
  submitProposalWith = reviewStatus => async (formValues, dispatch, props) => {
    try {
      const postingProposal = this.transformFormDataToProposalData(formValues, reviewStatus)
      this.setState({ postingProposal })
      const returnedProposal = await this.postProposal(postingProposal).then(switchProposalType)

      const { initiallyFetchedListing, listing } = formValues
      const modifiedListing = Object.assign({}, initiallyFetchedListing, listing)
      if (listing.shareMediaBetweenModels !== initiallyFetchedListing.shareMediaBetweenModels) {
        // APACSMDESK-45150 共用同組商品圖已被修改過, 不能拿原本抓來的資料直接丟去submit
        modifiedListing.shareMediaBetweenModels = listing.shareMediaBetweenModels // 改拿form的資料
      }
      const loadingProposal = await this.getProposalForLoading({
        proposal: returnedProposal,
        listing: modifiedListing
      })
      HistoryUtil.updateHistory({ id: loadingProposal.id })
      this.loadForm(loadingProposal)
      return loadingProposal
    } catch (error) {
      console.error('submitProposalWith fail', error)

      updateSyncErrorsByFormError({
        formError: error,
        updateFormSyncErrors: this.props.updateFormSyncErrors,
        transformer: proposalError => _.pick(proposalError, Object.keys(PRIMITIVE_FORM_DATA))
      })

      throw error
    }
  }

  render () {
    return (
      <BeforeUnload
        ref={r => (this.beforeunload = r)}
      >
        <UpdateListingForm
          {...this.props}
          ref={e => (this.form = e)}
          loadForm={this.loadForm}
          getFormData={this.getFormData}
          onFormSubmit={this.submitProposalWith(PROPOSAL_REVIEW_STATUS.PENDING_REVIEW)}
          onFormComplete={this.submitProposalWith(PROPOSAL_REVIEW_STATUS.DRAFT)}
          moveToErrorPage={this.moveToErrorPage}
          getUpdateFormRef={this.getCurrentUpdateFormRef}
          setUpdateFormRef={this.setCurrentUpdateFormRef}
          postingProposal={this.state.postingProposal}
        />
      </BeforeUnload>
    )
  }
}

const hoc = _.flow([
  withSupplierSharedLink,
  withI13nWrapper,
  withCommonPage,
  withUpdateListingForm
])

export default hoc(UpdateListingMain)
